import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { HttpLoadingService } from '@core/services/http-loading.service';

/** Set on a request to opt out of the global HTTP loader, e.g. background polling. */
export const SKIP_GLOBAL_HTTP_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  private readonly loading = inject(HttpLoadingService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.context.get(SKIP_GLOBAL_HTTP_LOADER)) {
      return next.handle(req);
    }

    this.loading.begin();
    return next.handle(req).pipe(finalize(() => this.loading.end()));
  }
}
